import {isDistinctCanvasImageId} from '../../../../shared/savedBrandAdCanvas';
/** Recover server images without replacing the user's layout or duplicating canonicalized IDs. */
export function reconcileImagePositions<T extends {id:string;src:string}>(current:T[],restored:T[],isVirtual:(image:T)=>boolean):T[]{
 const canonicalById=new Map(restored.map(image=>[image.id,image]));
 const reserved=new Set(current.filter(image=>canonicalById.has(image.id)).map(image=>image.id));
 const used=new Set<string>();
 const result:T[]=[];
 for(const image of current){
  const canonical=canonicalById.get(image.id)??(!isDistinctCanvasImageId(image.id)?restored.find(row=>!isDistinctCanvasImageId(row.id)&&row.src===image.src&&!used.has(row.id)&&!reserved.has(row.id)):undefined);
  if(canonical){
   if(used.has(canonical.id))continue;
   used.add(canonical.id);
   result.push(isVirtual(image)?canonical:canonical.id===image.id?image:{...image,id:canonical.id});
  }else if(!isVirtual(image)){result.push(image);}
 }
 for(const image of restored)if(!used.has(image.id)){result.push(image);used.add(image.id);}
 return result.length===current.length&&result.every((image,index)=>image===current[index])?current:result;
}
